'use strict';

import { fetchAnimalForAdoption, fetchFilterData } from "./services";

const animalListPage = jQuery(".animal-listing--view-page");
const animalListContainer = animalListPage.find("#animal-list");
const fallbackImage = "/themes/custom/rspca/images/rspca_placeholder.png";

let isLoadingMore = false;
let lastRecordId = null;
let defaultParams = null;
let animalPath = "/pet"; 
let limit = 6;

const adoptionListStatus = "Available For Adoption;Available for Adoption-In Foster;Available for Adoption-No web Prescence;Available for Adoption-Offsite;Trail adoption";

export const initAdoptListing = async () => {
	if (animalListPage.length < 1) return;

	try {
		const params = getUrlParams();
		const animalType = params.get("field_animal_type");
		const animalLocation = params.get("field_location");
		const animalStatus = params.get("field_status");

		let status;
		let animalListingFilterParams = {};

		if(animalType && animalType != "All") {
			animalListingFilterParams["AnimalType"] = animalType;
		}
		
		if(animalLocation && animalLocation != 'All') {
			animalListingFilterParams["LocationName"] = animalLocation;
		}

		if(animalStatus && animalLocation != '') {
			animalListingFilterParams["AnimalStatus"] = animalStatus;
		}

		const animalListParagraph = animalListContainer.closest('.paragraph--type--animal-os-listing');
		
		if(animalListParagraph.length == 1 && animalListParagraph.data('status')) {
			status = animalListParagraph.data('status');
			
			animalListingFilterParams["AnimalStatus"] = (status == 'lost_and_found') ? animalStatus : adoptionListStatus;
		}

		if(animalListParagraph.length == 1 && animalListParagraph.data('path')) {
			animalPath = animalListParagraph.data('path');
		}
		
		if(animalListParagraph.length == 1 && animalListParagraph.data('limit')) {
			limit = animalListParagraph.data('limit');
		
			if ((limit > 0 && limit <= 12)) {
				animalListingFilterParams["Limit"] = limit;
			}
		}


		if(status == 'lost_and_found' && !animalStatus) {
			showLostAndFoundOptions();
			return;
		}

		

		const [filterData, animalData] = await Promise.all([
			fetchFilterData(),
			fetchAnimalForAdoption(animalListingFilterParams)
		]);

		const { animals, recordsLeft } = animalData;

		if (animals && animals.length > 0 && recordsLeft > 0) {
			const lastAnimalOnList = animals.slice(-1)[0];
			lastRecordId = lastAnimalOnList.Id;
		}
		
		defaultParams = animalListingFilterParams;
		buildFilterForm(animalType, animalLocation, animalStatus);
		showAnimalListing(animalData);
		
		if(status !== 'lost_and_found') {
			animalListPage.find('.js-form-item-field-lost_found_date').remove();
			animalListPage.find('.js-form-item-field-lost_found_location').remove();
			animalListPage.find('.js-form-item-field-status').remove();
		} else {
			animalListPage.find('.js-form-item-field-location').remove();
		}

		initWaypoint();
	} catch (error) {
		console.error(error);
	} finally {
		animalListContainer.removeClass("loading");
	}
}


const initWaypoint = () => {
	let lastScrollTop = 0;

	// Function to check if an element is at the bottom of the viewport
	function isElementAtBottom(element) {
		const rect = element.getBoundingClientRect();
		return rect.bottom <= window.innerHeight;
	}

	// Function to determine the scroll direction
	function getScrollDirection() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const scrollDirection = scrollTop > lastScrollTop ? 'down' : 'up';
		lastScrollTop = scrollTop;
		return scrollDirection;
	}

	// Example usage: Check if an element with id "myElement" is at the bottom of the viewport
	const myElement = document.getElementById('animal-list');

	window.addEventListener('scroll', () => {
		if (isElementAtBottom(myElement)) {
			const scrollDirection = getScrollDirection();
			
			if (scrollDirection == 'down' && !isLoadingMore && lastRecordId) {
				animalListContainer.find(".load-more-wrapper").remove();
				handleLoadMore({
					...defaultParams,
					LastRecordId: lastRecordId
				});
			}
		}
	});
}

const showAnimalListing = (data, firstLoad = true) => {
	const { animals, recordsLeft } = data;

	if(firstLoad && animals.length == 0) {
		animalListContainer.append(`
			<div class='container-xlarge'>
				<div class="text-sm leading-5 font-bold">No match found</div>
				<a href='${window.location.pathname}' alt='reset'>Reset</a>
			</div>	
		`)
		return;
	}

	let grid = animalListContainer.find('.grid');

	if (animalListContainer.find(".grid").length < 1) {
		grid = $("<div>", { class: "grid" });
		animalListContainer.append(grid);
	}

	animalListContainer.find(".load-more-wrapper").remove();

	if (lastRecordId) {
		const loadMoreWrapper = $(`
			<div class='flex items-center justify-center load-more-wrapper'>
				<a class='load-more mx-auto mt-medium button-sm button button-primary' data-lastrecordid='${lastRecordId}' href="#">
					Load more
				</a>
			</div>
    	`);

		loadMoreWrapper.on("click", ".load-more", async function (e) {
			e.preventDefault();
			let params = {};
			params.LastRecordId = $(this).data("lastrecordid");
			handleLoadMore(params);
			$(this).remove();
		})

		animalListContainer.append(loadMoreWrapper)
	} else {
		animalListContainer.find(".load-more-wrapper").remove();
	}

	
	animals.map(function (animal) {
		const gridItem = $("<div/>", { class: "grid-item" });
		
		const onedriveFiles = animal?.OneDrive_Files__r;

		let imageURL = fallbackImage;
		
		if(Array.isArray(onedriveFiles) && onedriveFiles.length >= 1) {
			imageURL =  (onedriveFiles.find(x => x?.Is_Primary__c))?.Thumbnail_URL__c || onedriveFiles[0].Thumbnail_URL__c;
		}
		
		let missingImageClass = '';
		
		if(!data?.OneDrive_Files__r?.Thumbnail_URL__c) {
			missingImageClass = 'fallback-image';
		}

		gridItem.html(`
			<div class='grid-image'>
				<img data-src='${imageURL}' src='${imageURL}' alt='${animal.animalos__Animal_Name__c}' class='${missingImageClass}' onerror="this.onerror=null;this.src='${fallbackImage}';"/>
			</div>
			<div class='grid-content'>
				<div class='my-small'><a href='${animalPath}?petId=${animal.Id}' class='text-2xl'>${animal.animalos__Animal_Name__c}</a></div>  
				<div>${animal.animalos__Primary_Breed__r.Name}</div>  
				<div>${animal?.Age_for_Adoption_Website__c || ''}</div>  
			</div>
		`);

		grid.append(gridItem);
	});
}

const showLostAndFoundOptions = () => {
	animalListPage.prepend(`
		<div class='flex container-text justify-center' style='gap:40px;'>
			<a href='${window.location.pathname}?field_status=found' alt='reset' class='button button-primary button-rounded text-center'>I am searching for my pet</a>
			<a href='${window.location.pathname}?field_status=lost' alt='reset' class='button button-primary button-rounded text-center'>I've found someone's pet</a>
		</div>	
	`)
}

const handleLoadMore = async (params) => {
	try {
		isLoadingMore = true;
		animalListContainer.addClass("loading");
		let data = await fetchAnimalForAdoption(params);
		const { animals, recordsLeft } = data;

		if (animals && animals.length > 0 && recordsLeft > 0) {
			const lastAnimalOnList = animals.slice(-1)[0];
			lastRecordId = lastAnimalOnList.Id;
		} else {
			lastRecordId = null;
		}

		showAnimalListing(data, false);
	} catch (error) {
		console.error("Error while loading more pet results.");
	} finally {
		isLoadingMore = false;
		animalListContainer.removeClass("loading");
		if (lastRecordId == null) {
			$('.path-adoption').addClass('no-more-pets');
		}
	}
}

const buildFilterForm = (animalType, animalLocation, animalStatus) => {
	const filterForm = animalListPage.find(".views-exposed-form");
	let isFiltered = 0;
	if(animalType) {
		filterForm.find('select[name="field_animal_type"]').val(animalType);
		isFiltered++;
	}

	if(animalLocation) {
		filterForm.find('select[name="field_location"]').val(animalLocation);
		isFiltered++;
	}

	if(animalStatus) {
		filterForm.find('select[name="field_status"]').val(animalStatus);
		isFiltered++;
	}
	
	if(isFiltered) {
		filterForm.find('input[type="submit"]').after(`<a href='${window.location.pathname}' class='ml-small button text-primary'>Reset</a>`);
	}
	// filterForm.find('select[name="field_location"]').remove();
	// filterForm.prepend(`<div class='container-xlarge mx-auto flex pt-small font-bold'>To do:</div>`);
	filterForm.addClass("active");
}

function getUrlParams() {
	const url = window.location.href;

	// Create a URL object
	const urlObj = new URL(url);

	// Use URLSearchParams to get the query parameters
	return new URLSearchParams(urlObj.search);
}